<template>
    <div class="device-type-manange relative">
        <div class="buttons" v-if="role_id != 2"  :style="{position:button_position}">
            <el-button :id="'hospitalAdd'" @click="addDoctor" v-if="role_id != 2">新增</el-button>
            <el-button  @click="getExpertInfo">导出资料</el-button>
        </div>

        <!-- 表单开始 -->
        <el-row class="inputs mg-20" :gutter="20" v-if="role_id != 2">
            <el-col :md="6" :lg="4" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">真实姓名：</span>
                <el-input v-model="user_name" placeholder="真实姓名模糊搜索"/>
            </el-col>
            <el-col :md="6" :lg="4" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">单位：</span>
                <el-select
                    clearable
                    v-model="hospital_id" placeholder="请选择单位" style="width: 100%;max-width: none !important;">
                    <el-option
                        v-for="item in allHospital"
                        :key="item.id"
                        :label="item.hospital_nick_name"
                        :value="item.id"
                        v-if="item.hospital_nick_name"
                    ></el-option>
                </el-select>
            </el-col>
            <el-col :md="6" :lg="5" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">签约时间：</span>
                <el-date-picker
                    v-model="search_expired_date"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    @change="dateChange"
                ></el-date-picker>
            </el-col>
        </el-row>
        <el-row class="inputs mg-20" :gutter="20" v-if="role_id != 2">
            <el-col :md="6" :lg="4" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">手机号码：</span>
                <el-input v-model="mobile" placeholder="手机号码模糊搜素"/>
            </el-col>
            <el-col :md="6" :lg="4" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">科室：</span>
                <el-select
                    clearable
                    v-model="hospital_department_id" placeholder="请选择科室" style="width: 100%;max-width: none !important;">
                    <el-option
                        v-for="item in allHospitalDepartment"
                        :key="item.id"
                        :label="item.department_name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-col>
            <el-col :md="6" :lg="5" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">状&ensp;&ensp;&ensp;&ensp;态：</span>
                <el-select
                    clearable
                    class="status" v-model="status" placeholder="请选择状态" style="max-width: none !important; width: 100% !important;">
                    <el-option
                        v-for="item in allStatus"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-col>
            <el-col :md="6" :lg="5" :xl="4" :sm="12" :xs="24">
                <el-button @click="resetForm">重置</el-button>
                <el-button @click="search">筛选</el-button>
            </el-col>
        </el-row >
        <!-- 表单结束 -->
        <div class="docker_buttons" v-if="role_id == 1 ||  (role_id == 3 && child_role_id == 0)">
            <el-button type="primary"  @click="addOperate" style="width: auto !important;">批量分配特属服务专员</el-button>
        </div>
        <el-table :data="tableData" border style="width: 100%" @selection-change="selectUser">
            <el-table-column v-if="role_id == 1 || (role_id == 3 && child_role_id == 0)"
                             type="selection"
                             width="40">
            </el-table-column>
            <!--            <el-table-column prop="user_id" label="ID" align="center" label-class-name="label"></el-table-column>-->
            <el-table-column width="50px" prop="no" label="序号" align="center" label-class-name="label" v-if="role_id != 2"></el-table-column>
            <el-table-column width="80px" prop="no" label="序号" align="center" label-class-name="label" v-if="role_id == 2"></el-table-column>
            <el-table-column width="100" prop="user_name" label="真实姓名" align="center" v-if="role_id == 1" label-class-name="label"></el-table-column>
            <el-table-column width="120" prop="user_name" label="真实姓名" align="center" v-if="role_id != 1" label-class-name="label"></el-table-column>
<!--            <el-table-column width="100" prop="idcard" label="身份证号" align="center"-->
<!--                             v-if="role_id == 1"-->
<!--                             label-class-name="label"></el-table-column>-->
<!--            <el-table-column width="165" prop="idcard" label="身份证号" align="center"-->
<!--                             v-else-->
<!--                             label-class-name="label"></el-table-column>-->
            <el-table-column width="110" prop="mobile" label="手机号码" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="120px" prop="doctor_title_name" label="职称" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="hospital_nick_name" label="单位" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="130px" prop="department_name" label="科室" align="center" v-if="role_id == 1" label-class-name="label"></el-table-column>
            <el-table-column width="160px" prop="department_name" label="科室" align="center" v-if="role_id != 1" label-class-name="label"></el-table-column>
            <el-table-column width="200px" class-name="admin_user_name" prop="admin_user_name" label="特属服务专员" align="center" v-if="role_id != 2 && child_role_id == 0" label-class-name="label"></el-table-column>
<!--            <el-table-column width="100px" prop="max_client" label="服务特属服务对象上限" align="center" label-class-name="label" v-if="role_id != 2"></el-table-column>-->
            <el-table-column width="180" prop="max_client" label="服务特属服务对象上限" align="center" label-class-name="label" ></el-table-column>
<!--            <el-table-column width="100px" prop="number" label="签约特属服务对象数" align="center" label-class-name="label" v-if="role_id != 2"></el-table-column>-->
            <el-table-column width="160px" prop="number" label="服务特属服务对象数" align="center" label-class-name="label"></el-table-column>
<!--            <el-table-column width="110"  prop="effective_number" label="签约生效特属服务对象数" align="center" label-class-name="label" v-if="role_id == 1"></el-table-column>-->
<!--            <el-table-column width="100"  prop="expired_number" label="签约过期特属服务对象数" align="center" label-class-name="label" v-if="role_id == 1"></el-table-column>-->
<!--            <el-table-column width="100"  prop="will_number" label="签约未生效特属服务对象数" align="center" label-class-name="label" v-if="role_id == 1"></el-table-column>-->
            <el-table-column width="110" prop="start_date" label="签约时间" align="center" v-if="role_id == 1" label-class-name="label"></el-table-column>
            <el-table-column width="120" prop="start_date" label="签约时间" align="center" v-if="role_id != 1 && role_id != 2" label-class-name="label"></el-table-column>
            <el-table-column width="60px" prop="status" label="状态" align="center" label-class-name="label"></el-table-column>
            <el-table-column width="240px" prop="address" label="操作" align="center" label-class-name="label" v-slot="scope">
                <el-button @click="goDetail(scope.row)" type="text" size="small">
                    查看
                </el-button>
                <el-button @click="getDoctorVisit(scope.row.user_id,scope.row.user_name)" type="text" size="small">排班表</el-button>
                <el-button @click="edit(scope.row)" type="text" size="small" v-if="role_id != 2">
                    编辑
                </el-button>
                <el-button @click="startStopDoctor(scope.row,2)" v-if="role_id != 2 && scope.row.status_number==1"
                           type="text"
                           size="small">停用
                </el-button>
                <el-button @click="startStopDoctor(scope.row,1)" v-if="role_id != 2 && scope.row.status_number==2"
                           type="text"
                           size="small">启用
                </el-button>
                <el-button @click="resetPassword(scope.row)" type="text" v-if="role_id != 2"
                           size="small">重置密码
                </el-button>
            </el-table-column>
        </el-table>
        <el-pagination
            class="mg-20 ta-r"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :page-sizes="[10, 25, 50, 100]"
            :total="total"
            :page-size="perpage"
            :current-page="page"
            @current-change="changePage"
            @size-change="changeSite"
            v-if="is_pagination_show"
        ></el-pagination>
        <el-dialog title="批量分配特属服务专员" :visible.sync="adduserDialog">
            <el-form label-position="right" :model="userForm" :rules="userRules" ref="userForm"
                     label-width="120px"
                     class="form" style="width: 80%;margin: 20px auto 0 auto;" autocomplete="off">
                <el-form-item label="特属专家" prop="user_ids">
                    <el-select v-model="userForm.user_ids"
                               multiple
                               placeholder="请选择负责特属专家"
                               style="width: 100%;">
                        <el-option
                            v-for="item in selectUsers"
                            :key="item.user_id"
                            :label="item.user_name"
                            :value="item.user_id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属公司" prop="company_id">
                    <el-select v-model="userForm.company_id" placeholder="请选择所属公司"
                               style="width: 100%;" @change="changeCompany">
                        <el-option
                            v-for="item in allCompany"
                            :key="item.id"
                            :label="item.company_name"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属部门" prop="department_id">
                    <el-select v-model="userForm.department_id" placeholder="请选择所属部门"
                               style="width: 100%;" @change="changeDeparment">
                        <el-option value="">请选择</el-option>
                        <el-option
                            v-for="item in allDepartment"
                            :key="item.id"
                            :label="item.department_name"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所属组" prop="group_id">
                    <el-select @change="changeGroup" v-model="userForm.group_id" placeholder="请选择所属组"
                               style="width: 100%;">
                        <el-option value="">请选择</el-option>
                        <el-option
                            v-for="item in allGroup"
                            :key="item.id"
                            :label="item.group_name"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="特属服务专员" prop="operate_user_ids">
                    <el-select v-model="userForm.operate_user_ids"
                               multiple
                               placeholder="请选择特属服务专员"
                               style="width: 100%;">
                        <el-option value="">请选择</el-option>
                        <el-option
                            v-for="item in allGroupUser"
                            :key="item.id"
                            :label="item.user_name"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="adduserDialog = false">取 消</el-button>
                <el-button type="success" @click="addOperateData('userForm')">保存</el-button>
            </div>
        </el-dialog>

        <el-dialog :title="dialog_visit" :visible.sync="visitFormVisible" @close="visitClose">
            <el-form label-position="right" :model="visitForm" :rules="visitsRules" ref="visitForm" label-width="90px"
                     class="form"
                     style="width: 80%;margin: 20px auto 0 auto;" autocomplete="off">
                <div style="text-align: right;margin-bottom: 10px;" v-if="!is_edit">
                    <el-button type="primary" @click="visitEdit">编辑</el-button>
                </div>
                <el-form-item label="排班地址" prop="address_id">
                    <el-select v-model="visitForm.address_id"
                               placeholder="请选择排班地址"
                               @change="addressChange"
                               style="width: 100%;">
                        <el-option
                            v-for="item in doctorAddress"
                            :key="item.id"
                            :label="item.address_info"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="排班时间表">
                    <el-carousel indicator-position="outside" arrow="never"
                                 :autoplay="false" height="180px" @change="visitCarouselChange"
                                 trigger=""
                                 ref="visitCarousel"
                                 :initial-index="activeIndex"
                                 :interval="10000"
                    >
                        <el-carousel-item v-for="date_arr in visit_date_arr">
                            <div class="visit_time_container" v-if="is_edit">
                                <div class="visit_time_box" v-for="(dat, i) in date_arr"
                                     :data-date="dat.date_val"
                                     :data-id="dat.id"
                                     :data-half="dat.half"
                                     :data-old-half="dat.old_half"
                                >
                                    <!-- 周一到周五 -->
                                    <div :class="dat.header_class" v-on:click.stop="dateSelect($event)">
                                        <div>
                                            <p>{{ dat.week }}</p>
                                            <p>{{ dat.date }}</p>
                                        </div>
                                    </div>
                                    <div :class="dat.am_class" v-on:click.stop="halfSelect($event)">
                                        <div>上午</div>
                                    </div>
                                    <div :class="dat.pm_class" v-on:click.stop="halfSelect($event)">
                                        <div>下午</div>
                                    </div>

                                </div>
                            </div>

                            <div class="visit_time_container" v-if="!is_edit">
                                <div class="visit_time_box" v-for="(dat, i) in date_arr">
                                    <!-- 周一到周五 -->
                                    <div :class="dat.header_class">
                                        <div>
                                            <p>{{ dat.week }}</p>
                                            <p>{{ dat.date }}</p>
                                        </div>
                                    </div>
                                    <div :class="dat.am_class">
                                        <div>上午</div>
                                    </div>
                                    <div :class="dat.pm_class">
                                        <div>下午</div>
                                    </div>

                                </div>
                            </div>

                        </el-carousel-item>
                    </el-carousel>

                </el-form-item>
            </el-form>



            <div slot="footer" class="dialog-footer" v-if="isShowVisitData == 1 && is_edit">
                <el-button @click="cancelEditVisit">取 消</el-button>
                <el-button type="success" @click="addVisitData('visitForm')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {check} from "@/utils/checkData";
import {authUrlCheck, base64Parser, getBase64Image, isMobile, loadFile} from "@/api/order";
import {getUserInfos} from "@/utils/userInfos";
import PizZip from "pizzip";
import Docxtemplater from "docxtemplater";
import {saveAs} from "file-saver";
import ImageModule from "docxtemplater-image-module-free";
import env from "@/api/env";
import {getFormatDate} from "@/utils/date";

export default {
    data() {
        return {
            role_id: 0,
            child_role_id: 0,
            admin_user_name: '',
            admin_user_mobile: '',
            page: 1,
            perpage: 10,
            total: 0,
            tableData: [],
            user_name: '',
            mobile: '',
            hospital_id: '',
            hospital_department_id: '',
            status: '',
            start_expired_date: '',
            end_expired_date: '',
            search_expired_date: [],
            allHospital: [],
            allHospitalDepartment: [],
            allStatus: [
                {
                    id: 1,
                    name: '启用'
                },
                {
                    id: 2,
                    name: '停用'
                },
            ],
            is_submit: false,
            adduserDialog: false,
            selectUsers: [],
            allCompany: [],
            allDepartment: [],
            allGroup: [],
            allGroupUser: [],
            userForm: {
                user_ids: [], // 批量分配服务专员
                company_id: "",
                department_id: "",
                group_id: "",
                operate_user_ids: [],
            },
            userRules: {
                user_ids: [
                    {required: true, message: "请选择特属专家", trigger: "blur"},
                ],
                company_id: [
                    {required: true, message: "请选择所属公司", trigger: "blur"},
                ],
                department_id: [
                    {required: true, message: "请选择所属部门", trigger: "blur"},
                ],
                group_id: [
                    {required: true, message: "请选择所属组", trigger: "blur"},
                ],
                operate_user_ids: [
                    {required: true, message: "请选择运营人员", trigger: "blur"},
                ],
            },
            doctorAddress: [],
            dialog_visit: "专家排班",
            visitFormVisible: false,
            isShowVisitData: 1,
            is_edit: false,
            is_more: true,
            visit_page: 1,
            last_date: '2023-02-06',
            activeIndex: 0,
            visitForm: {
                doctor_id: '',
                doctor_name: '',
                address_id: '',
                visit_dates: [],
            },
            visitsRules: {
                doctor_id: [{required: true, message: "缺少专家ID", trigger: "blur"}],
                address_id: [
                    {required: true, message: "请选择排班地址", trigger: "blur"},
                ],
                visit_dates: [
                    {required: true, message: "请选择签约日期", trigger: "blur"},
                ],
            },
            // 日期表
            visit_date_arr: [],
            // 已排班日期
            visit_date_res: [
                [
                    {date:"02/06", half: "selected", id: 0},
                    {date:"02/07", half: "selected", id: 0},
                    {date:"02/08", half: "selected", id: 0},
                    {date:"02/09", half: "selected", id: 0},
                    {date:"02/10", half: "selected", id: 0},
                    {date:"02/11", half: "", id: 0},
                    {date:"02/12", half: "", id: 0},
                ],

            ],
            is_pagination_show: true,
            button_position: 'absolute'
        };
    },
    created() {
        if (isMobile()) {
            this.button_position = 'static'
        }
        let userInfo = getUserInfos()
        if (userInfo) {
            this.role_id = parseInt(userInfo.role_id)
            this.child_role_id = parseInt(userInfo.child_role_id)
        }

        if (this.$route.params.hospital_department_id) {
            this.hospital_department_id = this.$route.params.hospital_department_id;
        }
        if (this.$route.params.hospital_id) {
            this.hospital_id = this.$route.params.hospital_id;
        }
        if (this.$route.query.hospital_department_id) {
            this.hospital_department_id = this.$route.query.hospital_department_id;
        }
        if (this.$route.query.hospital_id) {
            this.hospital_id = this.$route.query.hospital_id;
        }
        if (this.$route.query.status == 1) {
            this.status = 1
        }
        if (this.$route.query.start_time) {
            this.search_expired_date[0] = this.$route.query.start_time;
            this.start_expired_date = this.$route.query.start_time;
        }
        if (this.$route.query.end_time) {
            this.search_expired_date[1] = this.$route.query.end_time;
            this.end_expired_date = this.$route.query.end_time;
        }
        if (this.$route.params.status == 1) {
            this.status = 1
        }
        if (this.$route.params.start_time) {
            this.search_expired_date[0] = this.$route.params.start_time;
            this.start_expired_date = this.$route.params.start_time;
        }
        if (this.$route.params.end_time) {
            this.search_expired_date[1] = this.$route.params.end_time;
            this.end_expired_date = this.$route.params.end_time;
        }
    },
    mounted() {
        let prev_page = localStorage.getItem('prev_page');
        if (prev_page == 'doctor_add' || prev_page == 'doctor_edit' || prev_page == 'doctor_detail') {
            this.user_name = localStorage.getItem('doctor_list_user_name')
            this.mobile = localStorage.getItem('doctor_list_mobile')
            this.hospital_id = localStorage.getItem('doctor_list_hospital_id')
            this.hospital_department_id = localStorage.getItem('doctor_list_hospital_department_id')
            this.status = parseInt(localStorage.getItem('doctor_list_status'))||''
            this.start_expired_date = localStorage.getItem('doctor_list_start_expired_date')
            this.end_expired_date = localStorage.getItem('doctor_list_end_expired_date')
            localStorage.getItem('prev_page', 'doctor_list')
            this.page = parseInt(localStorage.getItem('page'))||1
            this.perpage = parseInt(localStorage.getItem('perpage'))||10
            if (this.user_name == 'undefined' || this.user_name == 'null') {
                this.user_name = ''
            }
            if (this.mobile == 'undefined' || this.mobile == 'null') {
                this.mobile = ''
            }
            if (this.hospital_id == 'undefined' || this.hospital_id == 'null') {
                this.hospital_id = ''
            }
            if (this.hospital_department_id == 'undefined' || this.hospital_department_id == 'null') {
                this.hospital_department_id = ''
            }
            if (this.status == 'undefined' || this.status == 'null') {
                this.status = ''
            }
            if (this.start_expired_date == 'undefined' || this.start_expired_date == 'null') {
                this.start_expired_date = ''
            }
            if (this.end_expired_date == 'undefined' || this.end_expired_date == 'null') {
                this.end_expired_date = ''
            }
            this.search_expired_date = [this.start_expired_date, this.end_expired_date]
            this.is_pagination_show = false
        }


        // 获取特属专家列表
        this.getList();

        // 获取所有单位类型
        this.listParams();



    },
    methods: {
        courseEvent() {
            setTimeout(()=>{
                let courseObj = document.getElementsByClassName('el-carousel__button')
                for (let i = 0; i < courseObj.length; i++) {
                    courseObj[i].addEventListener('click', function () {
                        console.log('course obj...')
                    }, 500)
                }

            })
        },
        // 获取所有设备类型
        getList() {
            let params = {
                servername: 'Ruyi_AdminExpertServices',
                method: 'listing',
                pageinfo: {
                    page: this.page,
                    perpage: this.perpage,
                },
                params: {
                    user_name: this.user_name,
                    mobile: this.mobile,
                    hospital_id: this.hospital_id,
                    hospital_department_id: this.hospital_department_id,
                    status: this.status,
                    start_expired_date: this.start_expired_date,
                    end_expired_date: this.end_expired_date,
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    this.is_submit = false;
                    return;
                }
                for (var i = 0; i < res.data.data.list.length; i++) {
                    // 以序号代替ID
                    res.data.data.list[i].no = (this.page - 1) * this.perpage + i + 1

                    switch (res.data.data.list[i].status) {
                        case '1':
                            res.data.data.list[i].status = '启用';
                            res.data.data.list[i].status_number = '1';
                            break;
                        case '2':
                            res.data.data.list[i].status = '停用';
                            res.data.data.list[i].status_number = '2';
                            break;
                    }
                }
                this.tableData = res.data.data.list;
                this.total = res.data.data.page.count;
                this.is_submit = false;

                localStorage.setItem('doctor_list_user_name', this.user_name)
                localStorage.setItem('doctor_list_mobile', this.mobile)
                localStorage.setItem('doctor_list_hospital_id', this.hospital_id)
                localStorage.setItem('doctor_list_hospital_department_id', this.hospital_department_id)
                localStorage.setItem('doctor_list_status', this.status)
                localStorage.setItem('doctor_list_start_expired_date', this.start_expired_date)
                localStorage.setItem('doctor_list_end_expired_date', this.end_expired_date)
                localStorage.setItem('prev_page', 'doctor_list')
                localStorage.setItem('page', this.page)
                localStorage.setItem('perpage', this.perpage)
                this.is_pagination_show = true
            }).catch(() => {
                this.is_submit = false;
            }).finally(() => {
                this.is_submit = false;
            });
        },

        listParams() {
            let params = {
                servername: 'Ruyi_AdminExpertServices',
                method: 'listParams',
                pageinfo: {
                    page: this.page,
                    perpage: this.perpage,
                },
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.allHospital = res.data.data.hospital;
                this.allHospitalDepartment = res.data.data.hospital_department;
            });
        },

        // 改变每页条数
        changeSite(index) {
            this.perpage = index;
            this.getList();
        },

        //更换页码
        changePage(index) {
            this.page = index;
            this.getList();
        },

        // 重置按钮
        resetForm() {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复操作',
                    duration: 1500,
                });
                return;
            }
            this.is_submit = true;
            this.user_name = "";
            this.mobile = "";
            this.hospital_id = "";
            this.hospital_department_id = "";
            this.status = "";
            this.start_expired_date = "";
            this.end_expired_date = "";
            this.search_expired_date = "";
            this.page = 1;
            this.getList();
        },
        dateChange(e){
            if (!e) {
                this.search_expired_date = null
                this.start_expired_date = ''
                this.end_expired_date = ''
            }
        },
        // 搜索
        search() {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复操作',
                    duration: 1500,
                });
                return;
            }
            this.is_submit = true;
            if (this.search_expired_date) {
                this.start_expired_date = this.search_expired_date[0];
                this.end_expired_date = this.search_expired_date[1];
            }

            this.page = 1;
            this.getList();
        },

        // 跳转添加页
        addDoctor() {
            if (this.role_id > 1) {
                if (!authUrlCheck('/admin/doctor/DoctorAdd', this.$store.getters.authUrl)) {
                    return;
                }
            }
            this.$router.push({name: "doctorAdd", params: {}});
            return;
        },

        // 跳转详情页
        goDetail(data) {
            if (this.role_id > 1) {
                if (!authUrlCheck('/admin/doctor/DoctorDetail', this.$store.getters.authUrl)) {
                    return;
                }
            }
            this.$router.push({
                name: "doctorDetail",
                query: {user_id: data.user_id}
            });
            return;
        },
        // 跳转编辑页
        edit(data) {
            if (this.role_id > 1) {
                if (!authUrlCheck('/admin/doctor/DoctorEdit', this.$store.getters.authUrl)) {
                    return;
                }
            }
            this.$router.push({
                name: "doctorEdit",
                params: {user_id: data.user_id}
            });
            return;
        },
        // 启用停用特属专家
        startStopDoctor(data, status) {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复操作',
                    duration: 1500,
                });
                return;
            }
            this.is_submit = true;

            if (status == '1') {
                var message = `确定启用特属专家：${data.user_name}？`;
            }
            if (status == '2') {
                var message = `确定停用特属专家：${data.user_name}？`;
            }
            this.$confirm(message, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let params = {
                    servername: 'Ruyi_AdminExpertServices',
                    method: 'startStopDoctor',
                    pageinfo: {
                        page: this.page,
                        perpage: this.perpage,
                    },
                    params: {
                        user_id: data.user_id,
                        status: status
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        this.is_submit = false;
                        return;
                    }
                    this.$message({
                        type: "success",
                        message: '修改成功',
                        duration: 1500,
                    });
                    this.getList();
                    this.is_submit = false;
                }).finally(() => {
                    this.is_submit = false;
                });
            }).catch(() => {
                this.is_submit = false;
            }).finally(() => {
                this.is_submit = false;
            });
        },

        // 重置密码
        resetPassword(data) {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复操作',
                    duration: 1500,
                });
                return;
            }
            this.is_submit = true;
            this.$confirm(`确定重置 "${data.user_name}" 的密码吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let params = {
                    servername: 'Ruyi_AdminExpertServices',
                    method: 'resetPassword',
                    pageinfo: {
                        page: this.page,
                        perpage: this.perpage,
                    },
                    params: {
                        user_id: data.user_id,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        this.is_submit = false;
                        return;
                    }
                    this.$message({
                        type: "success",
                        message: '重置成功',
                        duration: 1500,
                    });
                    this.is_submit = false;
                }).finally(() => {
                    this.is_submit = false;
                });
            }).catch(() => {
                this.is_submit = false;
            }).finally(() => {
                this.is_submit = false;
            });
        },
        // 获取特属专家资料资料
        getExpertInfo() {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复操作',
                    duration: 1500,
                });
                return;
            }
            this.is_submit = true;
            let params = {
                servername: 'Ruyi_AdminExpertServices',
                method: 'expertListing',
                params: {
                    user_name: this.user_name,
                    mobile: this.mobile,
                    hospital_id: this.hospital_id,
                    hospital_department_id: this.hospital_department_id,
                    status: this.status,
                    start_expired_date: this.start_expired_date,
                    end_expired_date: this.end_expired_date,
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    this.is_submit = false;
                    return;
                }
                this.all_expert = res.data.data

                this.importinfo(res.data.data)

                this.is_submit = false;
            }).catch(() => {
                this.is_submit = false;
            }).finally(() => {
                this.is_submit = false;
            });
        },

        // 专家资料导出到word
        async importinfo(data) {
            let newDataArr = [];
            let user = [];
            let manager = [];
            let contracts = [];
            let type_name = '';
            let status_name = '';

            for (let k = 0; k < data.length; k++) {
                user = [];
                manager = [];
                contracts = [];
                type_name = '';
                status_name = '';

                // 特属服务对象
                if (data[k].doctorUsers) {
                    for (let i=0; i< data[k].doctorUsers.length;i++) {
                        user.push({
                            name: data[k].doctorUsers[i].user_name,
                            mobile: data[k].doctorUsers[i].mobile,
                            start_date: data[k].doctorUsers[i].start_date,
                            end_date: data[k].doctorUsers[i].expired_date,
                            status: data[k].doctorUsers[i].status == 1 ? '启用':'停用',
                        })
                    }
                }

                // 健康管理助理
                if(data[k].manager_list) {

                    for (let i=0; i< data[k].manager_list.length;i++) {
                        manager.push({
                            name: data[k].manager_list[i].user_name,
                            mobile: data[k].manager_list[i].mobile,
                            company: data[k].manager_list[i].company_name || '',
                            department: data[k].manager_list[i].department_name || '',
                            group: data[k].manager_list[i].group_name || '',
                            title_name: data[k].manager_list[i].title_name || '',
                            status: data[k].manager_list[i].status == 1 ? '启用':'停用',
                        })
                    }
                }

                // 签约记录
                if (data[k].allContract) {
                    for (let i=0; i< data[k].allContract.length;i++) {
                        type_name = data[k].allContract[i].contract_type == 2 ? '续约' : '新约';
                        contracts.push({
                            status: data[k].allContract[i].status == 2 ? '已确认' : '未确认',
                            type: type_name,
                            start_date: data[k].allContract[i].start_date || '',
                            end_date: data[k].allContract[i].expired_date || '',
                        })
                    }
                }

                newDataArr.push({
                    "avatar": await getBase64Image(env.IMG_COMMON_URL_PREFIX + data[k].doctor.user_avatar),
                    "user_name": data[k].doctor.user_name,
                    "status": data[k].doctor.status == 1 ? '启用' : '停用',
                    "title": data[k].doctor.doctor_title_name || ' ',
                    "idcard": data[k].doctor.idcard || ' ',
                    "hospital": data[k].doctor.hospital_name || ' ',
                    "department": data[k].doctor.department_name || ' ',
                    "mobile": data[k].doctor.mobile || ' ',
                    "expired_date": data[k].doctor.expired_date || ' ',
                    "max_client": data[k].doctor.max_client || 0,
                    "introduction": data[k].doctor.introduction || ' ',
                    "client_user_num": data[k].doctor.clienting_number || 0,
                    "history_user_num": data[k].doctor.log_client_number || 0,
                    "reservation_num": data[k].doctor.reservationing_number || 0,
                    "int_num": data[k].doctor.reservation_interrupt_number || 0,
                    "succ_num": data[k].doctor.reservationed_number || 0,
                    "user": user,
                    "manager": manager,
                    "contracts": contracts,
                })
            }

            loadFile(
                "detail-doctor.docx",
                // "user.docx",
                function (error, content) {

                    if (error) {
                        this.is_submit = false;
                        throw error;
                    }

                    const zip = new PizZip(content);

                    let imageOpts = {}
                    imageOpts.centered = true;  // 图片居中，在word模板中定义方式为{%%image}
                    imageOpts.fileType = "docx";
                    imageOpts.getImage = function (newImgUrl) {
                        return base64Parser(newImgUrl);
                    }
                    imageOpts.getSize = function () {
                        return [190, 190]
                    }

                    const doc = new Docxtemplater(zip, {
                        paragraphLoop: true,
                        linebreaks: true,
                        modules: [new ImageModule(imageOpts)],
                    });

                    doc.render({
                        "doctor_info": newDataArr
                    });

                    const out = doc.getZip().generate({
                        type: "blob",
                        mimeType:
                            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                    });
                    // Output the document using Data-URI
                    saveAs(out, "特属专家资料.docx");

                }
            );

        },
        selectUser(data) {

            let len = data.length
            let is_user_set = false;
            let is_id_set = false;
            this.selectUsers = [];
            this.userForm.user_ids = [];
            for (let i = 0; i < len; i++) {
                for (let j = 0; j < this.selectUsers.length; j++) {
                    if (data[i].user_id == this.selectUsers[j].user_id) {
                        is_user_set = true;
                        break;
                    }
                }

                if (!is_user_set) {
                    this.selectUsers.push({
                        user_id: data[i].user_id,
                        user_name: data[i].user_name
                    })
                    this.userForm.user_ids.push(data[i].user_id)
                }
            }
        },
        addOperate() {
            if (this.userForm.user_ids.length < 1) {
                this.$message({
                    type: "warning",
                    message: '请选择需要分配特属服务专员的特属专家',
                    duration: 1500,
                });
                return;
            }
            this.createParams()
            this.userForm.company_id = ''
            this.userForm.department_id = ''
            this.userForm.group_id = ''
            this.userForm.operate_user_ids = []
            this.adduserDialog = true;
        },
        async addOperateData(formName) {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复提交',
                    duration: 1500,
                });
                return;
            }

            this.is_submit = true;

            this.$refs[formName].validate(valid => {
                if (valid) {
                    let allUser = this.tableData;
                    let allUserLen = allUser.length;
                    let selectIds = this.userForm.user_ids;
                    let isOperateUser = [];
                    for (let i = 0; i < allUserLen; i++) {
                        for (let j = 0; j < selectIds.length; j++) {
                            if (allUser[i].user_id == selectIds[j] && allUser[i].operate_user_ids) {
                                // 修改服务专员提示
                                isOperateUser.push(selectIds[j])
                            }
                        }
                    }

                    if (isOperateUser.length > 0) {
                        this.$confirm('部分特属专家已有特属服务专员，是否确认修改', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {

                            this.submitFormComit();

                        }).catch(() => {

                            this.adduserDialog = false;
                            this.is_submit = false;
                        }).finally(() => {
                            this.is_submit = false;
                        });
                    } else {
                        this.submitFormComit();
                    }
                } else {
                    this.$message({
                        type: "error",
                        message: '请输入必填项'
                    });
                    this.is_submit = false;
                    return false;
                }
            });
        },
        async submitFormComit() {
            let params = {
                'servername': 'Ruyi_AdminExpertServices',
                'method': 'doctorAddOperate',
                'params': this.userForm
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    this.is_submit = false;
                    return;
                }
                this.$message({
                    type: "success",
                    message: '特属服务专员分配成功',
                    duration: 1500,
                });
                this.is_submit = false;
                this.adduserDialog = false;
                let _that = this;
                setTimeout(function () {
                    _that.selectUsers = [];
                    _that.userForm.user_ids = [];
                    _that.getList();
                }, 500)
            }).finally(() => {
                this.is_submit = false;
            });
        },
        createParams() {
            let params = {
                servername: 'Ruyi_AdminCustomerServices',
                method: 'createEditUserParams',
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.allCompany = res.data.data.company;
            });
        },
        changeCompany() {
            this.userForm.department_id = '';
            this.userForm.group_id = '';
            this.userForm.operate_user_ids = [];
            this.getAllDeparment();
        },
        changeDeparment() {
            this.userForm.group_id = '';
            this.userForm.operate_user_ids = [];
            this.getAllCompanyGroup();
        },
        getAllDeparment() {
            let params = {
                servername: 'Ruyi_AdminOperateServices',
                method: 'getAllCompanyDeparment',
                params: {
                    company_id: this.userForm.company_id,
                    status: 1
                }
            };
            this.allDepartment = [];
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.allDepartment = res.data.data;
            });
        },
        // 获取组成员
        changeGroup() {
            let params = {
                servername: 'Ruyi_AdminOperateServices',
                method: 'getAllGroupUser',
                params: {
                    company_id: this.userForm.company_id,
                    department_id: this.userForm.department_id,
                    group_id: this.userForm.group_id,
                    status: 1
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.allGroupUser = res.data.data;
            });
        },
        getAllCompanyGroup() {
            let params = {
                servername: 'Ruyi_AdminOperateServices',
                method: 'getAllCompanyGroup',
                params: {
                    company_id: this.userForm.company_id,
                    department_id: this.userForm.department_id,
                    status: 1
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.allGroup = res.data.data;
            });
        },
        dialogClose() {
            this.selectUsers = [];
            this.userForm.user_ids = [];
        },
        async cancelEditVisit() {
            this.is_edit = false;
            await this.addressChange();
        },
        // 查看专家排班
        getDoctorVisit(doctor_id, user_name) {
            this.last_date = getFormatDate('Y-m-d', ((new Date()).getTime() - 86400 * 1000)/1000)
            this.activeIndex = 0;
            this.visitForm.doctor_id = doctor_id;
            this.visitForm.doctor_name = user_name;
            this.dialog_visit = `${user_name}的排班表`;
            this.visitFormVisible = true;
            this.is_edit = false;
            this.is_more = true;

            this.getDoctorAddress()

            setTimeout(()=>{
                this.courseEvent()
            }, 500)
        },
        addressChange() {
            this.last_date = getFormatDate('Y-m-d', ((new Date()).getTime() - 86400 * 1000)/1000)
            this.activeIndex = 0;
            this.is_more = true;
            this.visit_page = 1;
            this.visit_date_arr = [];
            this.visit_date_res = [];

            let nowTime = new Date(); //当前的时间戳 毫秒
            let nowDay = nowTime.getDay(); // 当前是星期几
            let day = (nowDay > 0) ? nowDay : 7;
            let MonDayTime = nowTime - (day - 1) * 86400 * 1000; // 周一的时间戳 毫秒

            setTimeout(()=>{
                this.getVisitList()
                setTimeout(()=>{
                    this.getVisitArr(MonDayTime)
                }, 1000)
            },50)


        },
        getDoctorAddress() {
            let params = {
                servername: 'Ruyi_AdminWorkbenchServices',
                method: 'getAddress',
                params: {
                    doctor_id: this.visitForm.doctor_id
                }
            };
            this.doctorAddress = [];
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                if (res.data.data) {
                    this.doctorAddress = res.data.data;
                    for (let i = 0; i < this.doctorAddress.length; i++) {
                        if (!this.visitForm.address_id && (this.doctorAddress[i].is_default == 1 || this.doctorAddress.length == 1)) {
                            this.visitForm.address_id = this.doctorAddress[i].id;
                        }
                    }
                    if (this.visitForm.address_id) {
                        this.addressChange()
                    }
                }
            });
        },
        visitClose() {
            this.activeIndex = 0;
            this.visitFormVisible = false;
            this.is_edit = false;
            this.is_more = true;
            this.visit_page = 1;
            this.visit_date_arr = [];
            this.visit_date_res = [];
            this.doctorAddress = [];
            this.visitForm.doctor_id = '';
            this.visitForm.address_id = '';
            getFormatDate('Y-m-d', ((new Date()).getTime() - 86400 * 1000)/1000)
        },
        visitEdit() {
            this.is_edit = true;

            this.visit_date_arr = [];
            let nowTime = new Date(); //当前的时间戳 毫秒
            let nowDay = nowTime.getDay(); // 当前是星期几
            let day = (nowDay > 0) ? nowDay : 7;
            let MonDayTime = nowTime - (day - 1) * 86400 * 1000; // 周一的时间戳 毫秒
            this.getVisitArr(MonDayTime)
        },
        // 日期排班选项卡切换
        async visitCarouselChange() {
            let visit_date_arr_len = this.visit_date_arr.length
            let time = 0;
            let _that = this
            let activeIndex = this.$refs.visitCarousel.activeIndex;
            this.activeIndex = activeIndex

            if ((activeIndex + 1) == visit_date_arr_len) {
                // 切换到最后一个
                // 是否是编辑状态
                if (this.is_edit) {
                    this.visit_page += 1;
                    await this.getVisitList()
                    if (visit_date_arr_len < 12) {
                        if (visit_date_arr_len < 1) {
                            let nowTime = new Date(); //当前的时间戳 毫秒
                            let nowDay = nowTime.getDay(); // 当前是星期几
                            let day = (nowDay > 0) ? nowDay : 7;
                            time = nowTime - (day - 1) * 86400 * 1000; // 周一的时间戳 毫秒
                        } else {
                            time = ((new Date(this.visit_date_arr[visit_date_arr_len - 1][6].date_val)).getTime()) + 86401*1000
                        }
                        await this.getVisitArr(time)
                    }
                } else {
                    // 非编辑状态
                    // 是否还有更多
                    if (this.is_more) {
                        // 加载更多排班
                        this.visit_page += 1;
                        await this.getVisitList()
                        setTimeout(function () {
                            if (visit_date_arr_len < 1) {
                                let nowTime = new Date(); //当前的时间戳 毫秒
                                let nowDay = nowTime.getDay(); // 当前是星期几
                                let day = (nowDay > 0) ? nowDay : 7;
                                time = nowTime - (day - 1) * 86400 * 1000; // 周一的时间戳 毫秒
                            } else {
                                time = ((new Date(_that.visit_date_arr[visit_date_arr_len - 1][6].date_val)).getTime()) + 86401*1000
                            }
                            if (_that.is_more) {
                                _that.getVisitArr(time)
                            }
                        }, 500)
                    }
                }
            }

            if (this.is_edit) {
                if ((new Date(this.visit_date_arr[activeIndex][0].date_val)).getTime() > (new Date(this.last_date)).getTime()) {
                    for (let i = 0; i < 7; i++) {
                        if (i < 5) {
                            this.visit_date_arr[activeIndex][i].header_class = 'visit_time time_header selected'
                            this.visit_date_arr[activeIndex][i].am_class = 'visit_time time_am selected'
                            this.visit_date_arr[activeIndex][i].pm_class = 'visit_time time_pm selected'
                            this.visit_date_arr[activeIndex][i].half = '全天'
                        }
                    }
                }
            }

        },

        // 从后台获取排班数据
        getVisitList() {
            let params = {
                servername: 'Ruyi_AdminExpertServices',
                method: 'getDoctorVisits',
                pageinfo: {
                    page: this.visit_page,
                },
                params: {
                    doctor_id: this.visitForm.doctor_id,
                    address_id: this.visitForm.address_id
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                if (res.data.data) {
                    let dat = res.data.data
                    for (var i = 0; i < dat.length; i++) {
                        this.visit_date_res.push({
                            date: dat[i].visit_date,
                            half: dat[i].half,
                            id: dat[i].id,
                        })
                    }

                    this.last_date = dat[dat.length - 1].visit_date
                } else {
                    this.is_more = false;
                }

            }).catch((e) => {
                // console.log(e)
            });
        },
        getVisitArr(MonDayTime) {
            let nowTime = new Date(); //当前的时间戳 毫秒

            let arr = [];
            let time = 0;
            let select = '';
            let history = false;
            let res_arr = this.visit_date_res; // 排班时间
            let header_class = ''; // 日期class
            let am_class = ''; // 上午class
            let pm_class = ''; // 下午class
            let half = ''; // 新排班值
            let old_half = ''; // 旧排班值
            let id = 0; // id值
            let after_page = 0;
            let res_end = false;

            for (let i = 0; i < 4*7; i++) {
                history = false;
                time = MonDayTime + i * 86400 * 1000;
                if (i % 7 < 5) {
                    select = "selected";
                }
                if (time < (new Date(getFormatDate('Y-m-d', (nowTime.getTime())/1000))).getTime()) {
                    history = true;
                }

                if ((new Date(getFormatDate("Y-m-d", time/1000))).getTime() <= (new Date(this.last_date)).getTime()) {
                    // 排班表内时间
                    for (let j = 0; j < res_arr.length; j++) {

                        if (getFormatDate("Y-m-d", time/1000) == res_arr[j].date) {
                            id = res_arr[j].id
                            header_class = "visit_time time_header selected";
                            // 这一天有排班
                            switch (res_arr[j].half) {
                                case '全天':
                                    old_half = '全天';
                                    half = '全天';
                                    am_class = "visit_time time_am selected";
                                    pm_class = "visit_time time_pm selected";
                                    break;
                                case "上午":
                                    old_half = '上午';
                                    half = '上午';
                                    am_class = "visit_time time_am selected";
                                    pm_class = "visit_time time_pm";
                                    break;
                                case "下午":
                                    old_half = '下午';
                                    half = '下午';
                                    am_class = "visit_time time_am";
                                    pm_class = "visit_time time_pm selected";
                                    break;
                            }
                            break;
                        } else {
                            if (i % 7 < 5 && after_page > 0) {

                                header_class = "visit_time time_header selected";
                                am_class = "visit_time time_am selected";
                                pm_class = "visit_time time_pm selected";
                            } else {
                                header_class = "visit_time time_header";
                                am_class = "visit_time time_am";
                                pm_class = "visit_time time_pm";
                            }
                        }
                    }

                } else {
                    res_end = true;
                    // 排班表之后的时间
                    if (this.is_edit) {

                        if (
                            (after_page > 0
                            || time > ((new Date(this.last_date)).getTime()) + 86400*1000*7
                            || (new Date(this.last_date)).getTime() < (new Date().getTime()))
                            && (i % 7 < 5)
                        ) {
                            header_class = `visit_time time_header selected`;
                            am_class = `visit_time time_am selected`;
                            pm_class = `visit_time time_pm selected`;
                        } else {
                            header_class = `visit_time time_header`;
                            am_class = `visit_time time_am`;
                            pm_class = `visit_time time_pm`;
                        }
                        if (this.visit_date_arr.length == 0 && ((new Date(this.last_date)).getTime()) < (new Date()).getTime() && (i % 7 < 5)) {
                            half = '全天';
                        }
                    } else {
                        after_page = 1;
                        header_class = `visit_time time_header`;
                        am_class = `visit_time time_am`;
                        pm_class = `visit_time time_pm`;
                    }

                }

                if (this.is_edit) {
                    header_class = `${header_class} edit`;
                    am_class = `${am_class} edit`;
                    pm_class = `${pm_class} edit`;

                }
                if (history) {
                    header_class = `visit_time time_header history`;
                    am_class = `visit_time time_am history`;
                    pm_class = `visit_time time_pm history`;
                }
                arr.push({
                    date:getFormatDate("m/d", time/1000),
                    date_val:getFormatDate("Y-m-d", time/1000),
                    week: this.getWeek(time),
                    sel: select,
                    history: history,
                    old_half: old_half,
                    half: half,
                    id: id,
                    header_class: header_class,
                    am_class: am_class,
                    pm_class: pm_class,
                })
                id = '';
                am_class = '';
                pm_class = '';
                old_half = '';
                half = '';
                select = '';

                if ((i + 1)% 7 == 0) {
                    this.visit_date_arr.push(arr)
                    arr = [];
                    if (after_page == 1 && !this.is_edit) {
                        after_page = 0;
                        break;
                    }
                    if (res_end) {
                        after_page += 1;
                    }
                }

            }

        },
        getWeek(date) {
            let day = (new Date(date)).getDay();
            let week = '';
            switch (day) {
                case 0:
                    week = '周日';
                    break;
                case 1:
                    week = '周一';
                    break;
                case 2:
                    week = '周二';
                    break;
                case 3:
                    week = '周三';
                    break;
                case 4:
                    week = '周四';
                    break;
                case 5:
                    week = '周五';
                    break;
                case 6:
                    week = '周六';
                    break;
                default:
                    break;
            }
            return week;
        },
        // 选择日期
        dateSelect(obj) {
            let class_str = obj.currentTarget.className
            if (class_str.indexOf('selected') > -1) {
                // 取消选中
                obj.currentTarget.classList.remove('selected')
                obj.currentTarget.parentNode.getElementsByClassName('time_am')[0].classList.remove('selected')
                obj.currentTarget.parentNode.getElementsByClassName('time_pm')[0].classList.remove('selected')
                obj.currentTarget.parentNode.getElementsByClassName('time_pm')[0].setAttribute('data-half', '')
            } else {
                // 选中
                obj.currentTarget.classList.add('selected')
                obj.currentTarget.parentNode.getElementsByClassName('time_am')[0].classList.add('selected')
                obj.currentTarget.parentNode.getElementsByClassName('time_pm')[0].classList.add('selected')
                obj.currentTarget.parentNode.getElementsByClassName('time_pm')[0].setAttribute('data-half', '全天')
            }
        },
        // 选择上下午
        halfSelect(obj) {
            let class_str = obj.currentTarget.className
            let parent_node = obj.currentTarget.parentNode;
            let head_node = parent_node.getElementsByClassName('time_header')[0];
            let time_am = parent_node.getElementsByClassName('time_am')[0];
            let time_pm = parent_node.getElementsByClassName('time_pm')[0];
            if (class_str.indexOf('selected') > -1) {
                // 取消选中
                obj.currentTarget.classList.remove('selected')


                if (time_am.className.indexOf('selected') < 0 && time_pm.className.indexOf('selected') < 0) {
                    // 上下午都取消后自动取消日期勾选
                    head_node.classList.remove('selected')
                    parent_node.setAttribute('data-half', '')
                } else if(time_am.className.indexOf('selected') < 0 && time_pm.className.indexOf('selected') > -1 ) {
                    // 只取消上午
                    parent_node.setAttribute('data-half', '下午')
                } else if(time_am.className.indexOf('selected') > -1 && time_pm.className.indexOf('selected') < 0 ) {
                    // 只取消下午
                    parent_node.setAttribute('data-half', '上午')
                }
            } else {
                // 选中
                obj.currentTarget.classList.add('selected')
                if (head_node.className.indexOf('selected') < 0) {
                    head_node.classList.add('selected')
                }

                if(time_am.className.indexOf('selected') < 0 && time_pm.className.indexOf('selected') > -1 ) {
                    // 选中下午
                    parent_node.setAttribute('data-half', '下午')
                } else if(time_am.className.indexOf('selected') > -1 && time_pm.className.indexOf('selected') < 0 ) {
                    // 选中上午
                    parent_node.setAttribute('data-half', '上午')
                } else {
                    parent_node.setAttribute('data-half', '全天')
                }
            }
        },
        // 获取已选择日期
        getSelectDate() {
            let carouseNode = document.getElementsByClassName('visit_time_box')
            let carouselLen = carouseNode.length
            let visit_dates = [];
            let node_half = ''
            let old_half = ''
            let node_date = ''
            let node_id  = ''
            for (let i = 0; i < carouselLen; i++) {
                node_half = carouseNode[i].getAttribute('data-half')
                old_half = carouseNode[i].getAttribute('data-old-half')
                if (node_half != old_half) {
                    visit_dates.push({
                        visit_date:  carouseNode[i].getAttribute('data-date'),
                        id:  carouseNode[i].getAttribute('data-id'),
                        half:  carouseNode[i].getAttribute('data-half'),
                    })
                }
            }
            this.visitForm.visit_dates = visit_dates
        },
        async addVisitData(formName) {
            this.getSelectDate()

            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复提交',
                    duration: 1500,
                });
                return;
            }
            this.is_submit = true;
            let _that = this

            this.$refs[formName].validate(valid => {
                if (valid && this.visitForm.visit_dates.length > 0) {
                    let params = {
                        'servername': 'Ruyi_AdminExpertServices',
                        'method': 'createVisits',
                        'params': {
                            doctor_id: this.visitForm.doctor_id,
                            address_id: this.visitForm.address_id,
                            visit_date: this.visitForm.visit_dates,
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            this.is_submit = false;
                            return;
                        }
                        this.$message({
                            type: "success",
                            message: '排班表保存成功！',
                            duration: 1500,
                        });

                        _that.visit_date_arr = []
                        _that.visit_date_res = []
                        setTimeout(()=>{
                            this.getDoctorVisit(this.visitForm.doctor_id, this.visitForm.doctor_name)
                        }, 700)

                    }).catch(()=>{
                        this.is_submit = false;
                    }).finally(() => {
                        this.is_submit = false;
                    });
                } else {
                    this.is_submit = false;
                    return false;
                }
            });
        }
    }
};

</script>
<style lang="scss">
@import "@/styles/common.scss";

.docker_buttons {
    float: right;
    margin: 30px 0px 8px 0px;

    .el-button {
        width: auto;
        height: 32px;
        line-height: 7px;
    }
}
.el-table .admin_user_name .cell{
    white-space: pre-wrap;
}

.inputs .el-select.status .el-input {
    width: 100%;
}
.el-carousel__indicators--outside button{
    background: #006aff;
}
.el-carousel__button{
    height: 5px;
}
.visit_time_container {
    display: flex;flex-direction: row;
    padding: 20px 20px;
    width: 100%;box-sizing: border-box;
    .visit_time_box {
        width: 13%;margin-right: 1.5%;
        box-sizing: border-box;font-size: 14px;
        .visit_time {
            cursor: default;
            &.edit{
                cursor: pointer;
                :hover{
                    background: #02a7f0;
                    color: #fff;
                    border-radius:5px;
                }
            }
            border-radius:5px;
            background: #e9e9e9;
            &.time_am{
                margin-top: 10px;
                &.edit:hover{
                    background: #ccedfc;
                    color: #02a7f0;
                    border-radius:5px;
                }
                &.selected {
                    background: #ccedfc;
                    color: #02a7f0;
                }
            }
            &.time_pm{
                margin-top: 5px;
                &.edit:hover{
                    background: #ccedfc;
                    color: #02a7f0;
                    border-radius:5px;
                }
                &.selected {
                    background: #ccedfc;
                    color: #02a7f0;
                }
            }
            &.selected {
                background: #02a7f0;
                color: #fff;
            }
            &.time_header{
                p{
                    height: 1em;
                    line-height: 1em;
                    margin-top: 0;
                    margin-bottom: 0;
                    &:first-child{
                        padding-top:7px;padding-bottom: 0;
                    }
                    &:last-child{
                        padding-top: 0;padding-bottom: 7px;
                    }
                }
            }
            &.history {
                cursor: not-allowed;
            }

        }
        &:nth-child(7n+7){
            margin-right: 0;
        }
    }
}
.el-col{
    margin-bottom: 10px;
    input{
        width: 100%;
    }
}
.el-dialog{
    min-width: 480px !important;
}
.inputs .el-input {width: 100% !important;}
</style>
